export const iconFontAwesomeShoppingMoneyCheck = (
	<i className="fa-solid fa-money-check"></i>
);
